import axiosInstance from "../config/axiosInstance";
import { APIROUTE } from "../config/config";

export const getFundService = async () => {
    return (await axiosInstance.get(`${APIROUTE.allInfo}`)).data; 
}

export const getUserInfoService = async () => {
    return (await axiosInstance.get(`${APIROUTE.userInfo}`)).data; 
}